export const shapeWorldSide = 100;
export const symbols = {
    circle: [],
    triangle: [
        [50, 100],
        [0, 0],
        [100, 0],
        [50, 100]
    ],
    arrow: [
        [50, 100],
        [15, 0],
        [85, 0],
        [50, 100]
    ],
    square: [
        [0, 0],
        [100, 0],
        [100, 100],
        [0, 100],
        [0, 0]
    ],
    rectangle: [
        [0, 25],
        [100, 25],
        [100, 75],
        [0, 75],
        [0, 25]
    ],
    cross: [
        [0, 30],
        [0, 70],
        [30, 70],
        [30, 100],
        [70, 100],
        [70, 70],
        [100, 70],
        [100, 30],
        [70, 30],
        [70, 0],
        [30, 0],
        [30, 30],
        [0, 30]
    ],
    x: [
        [0, 20],
        [30, 50],
        [0, 80],
        [0, 100],
        [20, 100],
        [50, 70],
        [80, 100],
        [100, 100],
        [100, 80],
        [70, 50],
        [100, 20],
        [100, 0],
        [80, 0],
        [50, 30],
        [20, 0],
        [0, 0],
        [0, 20]
    ],
    building: [
        [50, 100],
        [0, 70],
        [0, 0],
        [100, 0],
        [100, 70],
        [50, 100]
    ],
    diamond: [
        [50, 0],
        [100, 50],
        [50, 100],
        [0, 50],
        [50, 0]
    ],
    chevron: [
        [50, 100],
        [0, 0],
        [50, 30],
        [100, 0],
        [50, 100]
    ]
};
